module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/pricing.json
// module id = 347
// module chunks = 93449047059328